import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { CityBreakTicketContainer } from './CityBreakTicket.styles'
import { FormattedMessage, useIntl } from 'react-intl'
import Price from 'components/shared/Price'
import Icon from 'components/shared/Icon'
import InlineTextList from 'components/shared/InlineTextList'
import { CityBreakTicketProps } from './CityBreakTicket.types'
import UseTicketTranslations from 'utils/hooks/useTicketTranslations'
import { useMemo } from 'react'

export const CityBreakTicket = ({
    ticketData,
    daysNumber,
    isPromoTicket,
}: CityBreakTicketProps) => {
    const { formatMessage } = useIntl()
    const { getTicketPersonByKey, getTicketZoneByKey, getTicketTypeByKey } =
        UseTicketTranslations()

    const {
        quantity,
        person,
        zone,
        ticketType,
        price,
        isFamilyPackage,
        isSeniorPackage,
    } = ticketData

    const translatedPersonName = getTicketPersonByKey(person) || ''
    const personName = useMemo(() => {
        if (isFamilyPackage)
            return formatMessage({
                id: 'package.family.title',
                defaultMessage: '_',
            })
        if (isSeniorPackage)
            return formatMessage({
                id: 'package.senior.title',
                defaultMessage: '_',
            })
        return translatedPersonName
    }, [translatedPersonName])

    return (
        <CityBreakTicketContainer>
            <>
                {/* number of tickets + persona */}
                <Box
                    direction="row"
                    align="center"
                    gap={[4, 8]}
                    className="person"
                >
                    <Text variant="bodySmall" color="grayscale_800">
                        {quantity}x
                    </Text>
                    <Box direction="row" align="center" gap={4}>
                        <Icon
                            variant="ticket"
                            color="secondary_500"
                            size={[16, 24]}
                        ></Icon>
                        <Text variant="bodySmall" color="grayscale_900">
                            {/* for city break promo tickets, adult types, use alternate person name */}
                            {isPromoTicket && person === 'adult'
                                ? formatMessage({
                                      id: 'promo.city_break.adult_ticket',
                                      defaultMessage: '_',
                                  })
                                : personName}
                        </Text>
                    </Box>
                </Box>

                {/* zones + ticket type */}
                <Box className="details">
                    <InlineTextList
                        variant="bodySmall"
                        color="grayscale_900"
                        items={[
                            getTicketZoneByKey(zone) || '',
                            getTicketTypeByKey(ticketType) || '',
                        ]}
                        gap={[8, 16]}
                    />
                </Box>

                {/* number of days + price */}
                <Box
                    direction={['column-reverse', 'row']}
                    align={['flex-end', 'baseline']}
                    gap={4}
                    className="price"
                >
                    {daysNumber > 1 && (
                        <Text variant="bodyExtraSmall" color="grayscale_800">
                            (
                            <FormattedMessage
                                id="global.plurals.days"
                                defaultMessage="_"
                                values={{
                                    days: daysNumber,
                                }}
                            />
                            )
                        </Text>
                    )}
                    <Price
                        value={isPromoTicket ? price * daysNumber : price}
                        size="bodySmallStrong"
                    />
                </Box>
            </>
        </CityBreakTicketContainer>
    )
}
